import { type ProjectFilterActions } from "@/features/projects/filter/projectFilterReducer";
import { endOfDay } from "date-fns";

export enum DateFilterOption {
  CREATED_DATE = "CREATED_DATE",
  UPDATED_DATE = "UPDATED_DATE",
  INSTALLATION_DATE = "INSTALLATION_DATE",
  EXPECTED_PURCHASE_DATE = "EXPECTED_PURCHASE_DATE",
}

export const dateUpdateAction = (
  dateRange: (Date | undefined)[],
  actions: ProjectFilterActions,
  option: DateFilterOption
) => {
  if (dateRange[0] && !dateRange[1]) {
    if (option === DateFilterOption.CREATED_DATE) {
      actions.setCreatedDate([dateRange[0], endOfDay(new Date())]);
    } else if (option === DateFilterOption.UPDATED_DATE) {
      actions.setUpdatedDate([dateRange[0], endOfDay(new Date())]);
    } else if (option === DateFilterOption.INSTALLATION_DATE) {
      actions.setInstallationDate([dateRange[0], endOfDay(new Date())]);
    } else if (option === DateFilterOption.EXPECTED_PURCHASE_DATE) {
      actions.setExpectedPurchaseDate([dateRange[0], endOfDay(new Date())]);
    }
    return;
  }

  if (option === DateFilterOption.CREATED_DATE) {
    actions.setCreatedDate(dateRange);
  } else if (option === DateFilterOption.UPDATED_DATE) {
    actions.setUpdatedDate(dateRange);
  } else if (option === DateFilterOption.INSTALLATION_DATE) {
    actions.setInstallationDate(dateRange);
  } else if (option === DateFilterOption.EXPECTED_PURCHASE_DATE) {
    actions.setExpectedPurchaseDate(dateRange);
  }
};
